export default __webpack_public_path__ + "static/media/17-BB-(1-1).049f5446.jpg";